/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module basic-styles/SAVE/SAVEediting
 */

import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import Command from '@ckeditor/ckeditor5-core/src/command';


const SOURCEDIALOG = 'sourcedialog';

const TPL = `
<div class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header py-1 px-2">
                <h5 class="modal-title" id="exampleModalLongTitle">Source</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body p-1">
                <textarea name="data" id="data" class="form-control cke_source"></textarea>
            </div>
            <div class="modal-footer p-1">
                <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-sm btn-primary btn-ok">Ok</button>
            </div>
        </div>
    </div>
</div>
`

/**
 * The source dialog editor.
 *
 * It registers the `'sourcedialog'` command
 *
 * @extends module:core/plugin~Plugin
 */

class DialogSourceCommand extends Command {
    execute(message) {
        let $window = $(window);
        let windowHeight = $window.height();
        let windowWidth = $window.width();
        let width = Math.min(windowWidth - 70, 800);
        let height = windowHeight / 1.5;
        let modal_id = "ck-source-dialog-modal";
        let oldData = "";
        let $modal = $("#" + modal_id);
        let self = this;
        if ($modal.length == 0) {
            $modal = $(TPL);
            $modal.appendTo("body");
            $modal.modal({
                backdrop: true,
                keyboard: true,
                focus: false,
                show: false
            });
        }
        let $textarea = $modal.find(".modal-body .cke_source");
        let $modal_dialog = $modal.find(".modal-dialog");
        let $okBtn = $modal.find(".btn-ok");
        $modal.on("show.bs.modal", function (e) {
            oldData = self.editor.getData();
            $textarea.val(oldData);
            $modal_dialog.css({ 'height': height, 'width': width + 10, 'max-width': width + 10 });
            $textarea.css({ 'height': height, 'width': width });
            $okBtn.off("click");
            $okBtn.on("click", function (e) {
                let newData = $textarea.val();
                if (newData != oldData) {
                    self.editor.setData(newData);
                    $modal.modal("hide");
                    self.editor.editing.view.focus();
                }

            })
        })

        $modal.modal('show');
        console.log("source code");
        console.log($modal);
        //this.editor.fire('save', arguments);
    }
}

export default class SourceDialogEditing extends Plugin {
	/**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;

        // Create SAVE command.
        editor.commands.add(SOURCEDIALOG, new DialogSourceCommand(editor, SOURCEDIALOG));

        // Set the Ctrl+B keystroke.
        //editor.keystrokes.set('CTRL+S', SAVE);
    }
}
